export default "__VITE_ASSET__nXnYvhvK__"